var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-meta left"},[_c('h3',{staticClass:"location-name"},[_vm._v(_vm._s(_vm.nameLookup[_vm.location.slug]))]),_vm._v(" "),_c('p',{style:(("font-size:" + _vm.fontSize))},[_vm._v(_vm._s(_vm.location.acf.location_address1)),_c('br'),_vm._v(_vm._s(_vm.location.acf.location_city)+", "+_vm._s(_vm.location.acf.location_state)),_c('br'),_vm._v(_vm._s(_vm.location.acf.location_phone))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c1213a3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menus/TogoMenuLocation.vue
// module id = 563
// module chunks = 0